import dynamic from "next/dynamic";
import type { GetServerSidePropsContext } from "next/types";

import type { NextPageWithLayout } from "pages/_app";

const GlobalSearchPage = dynamic(() => import("components/GlobalSearchPage"), {
  ssr: false,
});

const SearchPage: NextPageWithLayout = () => {
  return <GlobalSearchPage />;
};

export async function getServerSideProps(context: GetServerSidePropsContext) {
  return {
    props: {
      fallback: {},
    },
  };
}

export default SearchPage;
